import { IRenewalInvoiceState } from "./types";

export const FETCH_RENEWAL_INVOICE_STATUS = "fetchRenewalInvoiceStatus";
export const FETCH_RENEWAL_INVOICE_STATUS_SUCCESS =
  "fetchRenewalInvoiceStatusSuccess";
export const FETCH_RENEWAL_INVOICE_STATUS_ERROR =
  "fetchRenewalInvoiceStatusError";
export const CREATE_RENEWAL_INVOICE = "createRenewalInvoice";
export const CREATE_RENEWAL_INVOICE_SUCCESS = "createRenewalInvoiceSuccess";
export const CREATE_RENEWAL_INVOICE_ERROR = "createRenewalInvoiceError";

// Recovery code sent when renewal window has not opened yet.
export const RENEWAL_NOT_OPEN = "renewal_not_open";

// HTTP statuses with customer-readable error details.
export const SHOWABLE_ERROR_STATUSES = [409, 502];

export const initialState: IRenewalInvoiceState = {
  statusById: {},
  isFetchingById: {},
  isCreatingById: {},
  errorById: {},
  errorStatusSignatureById: {},
  statusFailedById: {},
  statusErrorById: {},
};
